import { mapState } from 'vuex'

export default {
    data() {
        return {
            isPlaying: false,
            audio: null
        }
    },

    computed: {
        ...mapState(['voices']),

        voiceList() {
            return this.voices || []
        }
    },

    methods: {
        /**
         * Toggle audio playback for a given voice ID
         * @param {string|number} id - Voice ID to play
         */
        toggleAudio(id) {
            // Stop the current audio if it's playing
            if (this.isPlaying && this.audio) {
                this.audio.pause()
                this.audio.currentTime = 0
                this.isPlaying = false
                return
            }

            // Lookup the voice from the voices list
            const selectedVoice = this.voiceList.find(voice => voice.id === id)

            // Play the new audio
            if (selectedVoice && selectedVoice.audio_url) {
                this.audio = new Audio(selectedVoice.audio_url)
                this.audio.play()
                this.audio.addEventListener('ended', this.stopAudio)
                this.isPlaying = true
            }
        },

        /**
         * Stop audio playback
         */
        stopAudio() {
            if (this.audio) {
                this.audio.pause()
                this.audio.currentTime = 0
                this.audio.removeEventListener('ended', this.stopAudio)
            }
            this.isPlaying = false
        }
    },

    beforeDestroy() {
        // Clean up audio when component is destroyed
        this.stopAudio()
    }
} 
